import queryString from 'query-string';
import { AppStateErrorType, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { TinkErrorReason, VerboseError } from '../stores/app-state-errors';

import { ApplicationResult } from '../utilities/post-notification-handler';

export class ApplicationErrorResult implements ApplicationResult {
  errorType: AppStateErrorType;

  errorStatus: ErrorStatus;

  message: string;

  credentialsId?: string;

  errorReason: TinkErrorReason;

  paymentRequestId?: string;

  credentialsDetailedErrorType?: string;

  credentialsDetailedDisplayMessage?: string;

  providerName?: string;

  trackingId: string;

  constructor(parameters: VerboseError) {
    const {
      errorStatus,
      localizedMessage,
      errorReason,
      errorType,
      paymentRequestId,
      credentialsDetailedErrorType,
      credentialsDetailedDisplayMessage,
      providerName,
      credentialsId,
      trackingId,
    } = parameters;

    this.errorType = errorType;
    this.errorStatus = errorStatus;
    this.message = localizedMessage;
    this.errorReason = errorReason;
    this.paymentRequestId = paymentRequestId;
    this.credentialsDetailedErrorType = credentialsDetailedErrorType;
    this.credentialsDetailedDisplayMessage = credentialsDetailedDisplayMessage;
    this.providerName = providerName;
    this.credentialsId = credentialsId;
    this.trackingId = trackingId;
  }

  buildQueryPath() {
    const result = {
      error: this.errorStatus,
      message: this.message,
      credentials: this.credentialsId,
      payment_request_id: this.paymentRequestId,
      error_type: this.credentialsDetailedErrorType,
      error_display_message: this.credentialsDetailedDisplayMessage,
      error_reason: this.errorReason,
      provider_name: this.providerName,
      tracking_id: this.trackingId,
    };

    return queryString.stringify(result);
  }

  buildIframeMessage() {
    let result;

    const baseError = {
      status: this.errorStatus,
      message: this.message,
      type: this.credentialsDetailedErrorType,
      displayMessage: this.credentialsDetailedDisplayMessage,
      reason: this.errorReason,
      providerName: this.providerName,
      trackingId: this.trackingId,
    };

    if (this.errorType === AppStateErrorType.CREDENTIALS) {
      result = {
        type: AppStateErrorType.CREDENTIALS,
        data: this.credentialsId,
        error: baseError,
      };
    } else {
      result = {
        type: AppStateErrorType.GENERAL_ERROR,
        error: {
          ...baseError,
          credentialsId: this.credentialsId,
        },
      };
    }

    return JSON.stringify(result);
  }
}
